var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.token !== '')?_c('div',{staticClass:"home-page"},[_c('Sidebar'),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }